export enum CHAIN_IDS {
  BSC = 56,
  BSC_TESTNET = 97,
  CRAT_TESTNET = 1979,
  CRAT = 2310,
  HOLESKY = 17000, // we use holesky as crat-testnet
}
